export const NOTIFICATION_PAGE_LIMIT = 10;
export const UNREAD_COUNT_CACHE_TTL_MS = 30 * 1000;
